import { hospitalsContactsTypes } from "../constantes/actionTypes"

const initialState = []

export const hospitalsContacts = (state = initialState, action) => {
    switch (action.type) {
        case hospitalsContactsTypes.GET_ALL_HOSPITALS_CONTACTS_SUCCESS:
            return action.payload
        case hospitalsContactsTypes.GET_ALL_HOSPITALS_CONTACTS_FAILURE:
            return initialState
        case hospitalsContactsTypes.GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_SUCCESS:
            return state.concat(action.payload)
        case hospitalsContactsTypes.GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_FAILURE:
            return initialState
        case hospitalsContactsTypes.CLEAR_ALL_HOSPITALS_CONTACTS:
            return initialState
        case hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_SUCCES:
            return state.filter(x => x.id_Contacto.toString() !== action.payload.toString())
        case hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_SUCCESS:
        case hospitalsContactsTypes.DELETE_ONE_HOSPITAL_CONTACT_SUCCESS:
            const hospList = state.map(x => {
                if (x.id_Contacto.toString() === action.payload.id_Contacto.toString())
                    return action.payload
                return x
            })
            return hospList
        
        case hospitalsContactsTypes.NEW_HOSPITALS_CONTACT_SUCCESS:
            return [...state, action.payload]
        case hospitalsContactsTypes.DELETE_ONE_HOSPITAL_CONTACT_FAILURE:
        case hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_FAILURE:
        case hospitalsContactsTypes.NEW_HOSPITALS_CONTACT_FAILURE:
        case hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_FAILURE:
            return state
        default:
            return state
    }
}   